<template>
  <div class="wrapper">
    <SuccessSvg class="success-svg" />

    <h3>
      {{ $t('common.success') }}
    </h3>

    <slot></slot>

    <div class="form-item">
      <button class="text-white primary-bg-color" v-on:click="$emit('goToApollo')">
        {{ $t('accept-invite.go-to-adspert') }}
      </button>
    </div>
  </div>
</template>

<script>
import SuccessSvg from '@/components/svg/success.svg';

export default {
  name: 'SuccessAcceptInvite',
  components: {
    SuccessSvg
  }
};
</script>

<style scoped>
.success-svg {
  max-width: 168px;
  margin: 32px 0;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper,
.form-item {
  width: 100%;
}

.form-item {
  margin-top: 64px;
}

button {
  outline: none;
}
</style>
